import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/main/api.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../services/global';
import { BaseCrudComponent } from '../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-current-version-report',
  templateUrl: './current-version-report.component.html',
  styleUrls: ['./current-version-report.component.css']
})
export class CurrentVersionReportComponent extends BaseCrudComponent {

    translations:any;
    header:any;
    momentjs: any = moment;
    curr_date:any;
    zones:any;
    theaders:any;

    exportAsConfig: ExportAsConfig = {
        type: 'xlsx',
        elementIdOrContent: 'exportable'
    };

    constructor(
        srv: ApiService,
        modalService: NgbModal,
        storage: Storage,
        router: Router,
        private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService
      ) {
          super(srv, modalService, storage, router);
          this.read_url = 'Portal/Versions';
          this.header = {};
          this.zones = [];

          this.theaders = [
              { field: 'userName', header: 'Usuario', sortable:true, sortfield:'userName', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'fullName', header: 'Nombre', sortable:true, sortfield:'fullName', styleC:{'text-align':'center'}, width:{'width.px': 250}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'agentCode', header: 'Código Agente', sortable:true, sortfield:'agentCode', styleC:{'text-align':'center'}, width:{'width.px': 200}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'versionNumber', header: 'Versión', sortable:true, sortfield:'versionNumber', styleC:{'text-align':'center'}, width:{'width.px': 140}, isColor:false, pre:'', pos:'', total:'', filter:'input'},
              { field: 'timeStamp', header: 'Fecha Versión', sortable:true, sortfield:'timeStamp', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', filter:'input'}
          ];
      }

    ngOnInit() {
        this.curr_date = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        //this.curr_date = this.momentjs().tz('America/Guayaquil');

        this.translate.getTranslation(this.translate.currentLang)
          .subscribe((translations) => {
                this.translations = translations;
                super.ngOnInit();
                this.getList();
          });
    }

    public getList(){
        var qst = this.read_url;
        var to:any;

        this.rows = [];

        this.loadingList = true;
        this.srv.getCall(qst).subscribe(x => {
            this.loadingList = false;

            if(x.status){
                var rs = x.data;
                this.rawdata = rs;
                this.rows = this.rawdata;
            }
        });
    }

    exportReport(){
        this.exportAsService.save(this.exportAsConfig, 'versiones_'+this.curr_date).subscribe(() => {
          // save started
        });
    }

}
